import superagent from "superagent"

import { API_URL } from "./base.ts"

export function GetAvailableDeliverySlots(
  venueId,
  latitude,
  longitude,
  isTakeaway
) {
  const URL = isTakeaway
    ? `${API_URL}/venues/${venueId}/available_take_away_slots`
    : `${API_URL}/venues/${venueId}/available_delivery_slots`

  return new Promise((resolve, reject) => {
    superagent
      .get(URL)
      .query({ latitude, longitude })
      .set("Accept", "application/json")
      .end((error, res) => {
        if (!error && res.ok) {
          resolve(res.body.result)
        } else {
          reject(res?.body?.errors || error)
        }
      })
  })
}

export function GetSearchedServices(queryString, venueIds = []) {
  const URL = `${API_URL}/services`
  let venuesString = ""
  venueIds.forEach((id, index) => {
    venuesString += id + (index === venueIds.length - 1 ? "" : ",")
  })
  return new Promise((resolve, reject) => {
    superagent
      .get(URL)
      .query({ q: queryString, venue_ids: venuesString })
      .set("Accept", "application/json")
      .end((error, res) => {
        error ? reject(res.body.errors) : resolve(res.body.result)
      })
  })
}

export function getVenues(location, query = {}) {
  let url = `${API_URL}/venues/search?latitude=${location.latitude}&longitude=${location.longitude}`
  query.venue_types = "shop"

  return new Promise((resolve, reject) => {
    superagent
      .get(url)
      .query(query)
      .end(function (err, res) {
        if (!err && res.ok) {
          resolve(res.body.result)
        } else if (res) {
          reject(res.errors)
        } else {
          reject(err)
        }
      })
  })
}

export function getServiceSection(sectionId) {
  let url = `${API_URL}/service_sections/${sectionId}`

  return new Promise((resolve, reject) => {
    superagent
      .get(url)
      .query({})
      .end(function (err, res) {
        if (!err && res.ok) {
          resolve(res.body.result)
        } else if (res) {
          reject(res.errors)
        } else {
          reject(err)
        }
      })
  })
}

export function getServiceSectionsPreview(venueId) {
  let url = `${API_URL}/venues/${venueId}/service_sections`

  return new Promise((resolve, reject) => {
    superagent
      .get(url)
      .query({})
      .end(function (err, res) {
        if (!err && res.ok) {
          resolve(res.body.result)
        } else if (res) {
          reject(res.errors)
        } else {
          reject(err)
        }
      })
  })
}
